import script from "./FooterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterComponent.vue?vue&type=script&lang=ts&setup=true"

import "./FooterComponent.vue?vue&type=style&index=0&id=5503e7dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5503e7dd"]])

export default __exports__